/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LiquidationReentrancyGuard,
  LiquidationReentrancyGuardInterface,
} from "../LiquidationReentrancyGuard";

const _abi = [
  {
    inputs: [],
    name: "LiquidationReentrancyCall",
    type: "error",
  },
];

export class LiquidationReentrancyGuard__factory {
  static readonly abi = _abi;
  static createInterface(): LiquidationReentrancyGuardInterface {
    return new utils.Interface(_abi) as LiquidationReentrancyGuardInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LiquidationReentrancyGuard {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LiquidationReentrancyGuard;
  }
}
